import * as React from "react";
import { forwardRef } from "react";
const SvgBigArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 10, viewBox: "0 0 13 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.00635 1.01172L11.0063 5.00972L7.00635 9.01172", stroke: "#2B2B2B", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.0063 5.01172L1.00635 5.01172", stroke: "#2B2B2B", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgBigArrowRight);
export default ForwardRef;
